export default __webpack_public_path__ + "static/media/carlLoryR2E.ed653afe.png";